import React, { Component } from "react";
import { withCurrentDevices } from "../../../shared/containers/containerCurrentDevice";

import styles from "./cmsConnectorSensorTools.module.scss";
import { TextField } from "@mui/material";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import { states } from "../../../reducers/queriesStates";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Preloader from "../../../shared/items/static/preloader";
import Scrollbars from "react-custom-scrollbars-2";
import UploadFile from "../UploadFile/UploadFile";
import ButtonIconWrapper from "../../../shared/items/contols/buttonIconWrapper";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

class CmsColibrations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inValue: null,
      outValue: null,
      error: null,
    };
  }

  componentDidUpdate(prevProps) {
    const { createCalibrationDataState, errors } = this.props;

    if (createCalibrationDataState === states.FAILURE && prevProps.createCalibrationDataState === states.REQUEST) {
      this.setState({ error: errors });

      setTimeout(() => {
        this.setState({ error: null });
      }, 3000);
    }

    if (createCalibrationDataState === states.READY && prevProps.createCalibrationDataState === states.REQUEST) {
      this.setState({ inValue: null, outValue: null });
    }
  }

  onChangeInValue(e) {
    this.setState({ inValue: e.target.value });
  }

  onChangeOutValue(e) {
    this.setState({ outValue: e.target.value });
  }

  isNullOrEmpty(value) {
    return value === null || value === "";
  }

  onCreateCalibration() {
    const { selectId, onCreateCalibration } = this.props;
    const { inValue, outValue } = this.state;
    onCreateCalibration({ id: selectId, calibration: { inValue, outValue } });
  }

  onDeleteCalibration(calibrationId) {
    const { selectId, onDeleteCalibration } = this.props;
    onDeleteCalibration({ id: selectId, calibrationId });
  }

  onUploadCalibrations(data) {
    const { selectId, onUploadCalibrations } = this.props;

    onUploadCalibrations(selectId, data);
  }

  onDownloadCalibrations() {
    const { selectId, onDownloadCalibrations, currentDevice } = this.props;
    const connectedSensor = currentDevice.connectedSensors.filter((x) => x.id === selectId)[0];

    onDownloadCalibrations(selectId, currentDevice.imei, connectedSensor.sensor.title);
  }

  render() {
    const { selectId, createCalibrationDataState, deleteCalibrationDataState, currentDevice } = this.props;
    const { inValue, outValue, error } = this.state;

    if (selectId === null) {
      return null;
    }

    const connectedSensor = currentDevice.connectedSensors.filter((x) => x.id === selectId)[0];

    return (
      <div className={styles.cmsCalibrationContainer}>
        <div className={styles.cmsCalibrationErrorContainer}>{error}</div>
        <div className={styles.loadsToolContainer}>
          {connectedSensor.calibrations.length > 0 ? (
            <FileDownloadIcon
              fontSize="large"
              onClick={(e) => {
                e.stopPropagation();
                this.onDownloadCalibrations();
              }}
            />
          ) : null}

          <UploadFile onUpload={this.onUploadCalibrations.bind(this)} />
        </div>

        <div className={styles.cmsColibrationInputContainer}>
          <div className={styles.cmsColibrationInputField}>
            <TextField
              value={inValue === null ? "" : inValue}
              id="outlined-basic"
              label="Значение входа"
              variant="outlined"
              size="small"
              type="number"
              onChange={this.onChangeInValue.bind(this)}
            />
          </div>

          <div className={styles.cmsColibrationInputField}>
            <TextField
              value={outValue === null ? "" : outValue}
              id="outlined-basic"
              label="Значение выхода"
              variant="outlined"
              size="small"
              type="number"
              onChange={this.onChangeOutValue.bind(this)}
            />
          </div>

          <div className={styles.cmsColibrationAddButton}>
            {createCalibrationDataState === states.REQUEST || deleteCalibrationDataState === states.REQUEST ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Preloader />
              </div>
            ) : !this.isNullOrEmpty(inValue) && !this.isNullOrEmpty(outValue) ? (
              <TooltipWrapper title={"Добавить эелемент таррировки"} position="left">
                <ControlPointIcon fontSize="large" onClick={this.onCreateCalibration.bind(this)} />
              </TooltipWrapper>
            ) : null}
          </div>
        </div>

        <Scrollbars ref="scrollbar" style={{ height: 500 }} autoHide={false}>
          {connectedSensor.calibrations
            .sort((a, b) => (parseFloat(a.inValue) > parseFloat(b.inValue) ? 1 : parseFloat(b.inValue) > parseFloat(a.inValue) ? -1 : 0))
            .map((x) => {
              return (
                <div key={x.id} className={styles.cmsColibrationsContainer}>
                  <div className={styles.cmsColibrationItem}>{x.inValue}</div>
                  <div className={styles.cmsColibrationItem}>{x.outValue}</div>
                  <div>
                    {createCalibrationDataState === states.REQUEST || deleteCalibrationDataState === states.REQUEST ? null : (
                      <TooltipWrapper title={`Удалить элемент таррировки`} position="right">
                        <div onClick={this.onDeleteCalibration.bind(this, x.id)}>
                          <DeleteOutlineIcon fontSize="small" />
                        </div>
                      </TooltipWrapper>
                    )}
                  </div>
                </div>
              );
            })}
        </Scrollbars>
      </div>
    );
  }
}

export default withCurrentDevices(CmsColibrations);
